module.exports = __webpack_public_path__ + "media/home/ConnectIcon-07cf61af.png";